import React, { useState, useEffect, useRef, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import axios from 'axios';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import constants from '../../../constants';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const CustomInput = React.forwardRef((props, ref) => (
  <Fragment>
    <input
      className="input pad_lft_rht5"
      onClick={props.onClick}
      value={props.value}
      type="text"
      readOnly={true}
      ref={ref}
    />
    <span className="ficon pad_lft_rht10"><i className="fa fa-calendar"></i></span>
  </Fragment>
));

const Filter = (props) => {
  const typeahead = useRef();
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [hotelList, setHotelList] = useState([]);
  const [ota, setOta] = useState([]);

  useEffect(() => {
    getOTAList();
    // eslint-disable-next-line
  }, []);

  const handleSearch = (hotel) => {
    if (typeof hotel === 'undefined' || hotel === '') {
      return;
    }
    if (hotel.length > 2) {
      getHotelList(hotel);
    }
  };

  const getHotelList = (hotel) => {
    setShowSearchLoader(true);
    axios(serverUrl + 'property/gethotellisting', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param: { page: 1, limit: 10, hotelName: hotel } }
    }).then(response => {
      if (response.data.status === 'success') {
        setHotelList(response.data.data.list);
      }
      setShowSearchLoader(false);
    }).catch(error => {
      console.log(error);
      setShowSearchLoader(false);
    });
  };

  const getOTAList = () => {
    axios(serverUrl + 'common/getotalist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    }).then(response => {
      if (response.status === 200) {
        setOta(response.data);
      } else {
        // Optionally handle error
      }
    }).catch(error => {
      console.log(error);
    });
  };

  const reset = () => {
    if (typeahead.current && typeahead.current.getInstance) typeahead.current.getInstance().clear();
    props.reset();
  };

  const { params } = props;

  return (
    <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1">
      <div className="row gutters-5">
        {/* Hotel Typeahead */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <AsyncTypeahead
              ref={typeahead}
              inputProps={{ className: 'inputs' }}
              multiple={false}
              isLoading={showSearchLoader}
              options={hotelList}
              id={'hotel'}
              labelKey={'hotel'}
              minLength={3}
              align="justify"
              onSearch={handleSearch}
              placeholder={'Hotel'}
              filterBy={['hotel','hotel_code']}
              selectHintOnEnter
              onInputChange={selected => props.typeheadInputChange(selected, 'hotelName')}
              onChange={selected => props.paramChange(selected, 'hotelName')}
              renderMenuItemChildren={(option, props) => (
                <span key={option.hotel_id} id={option.hotel_id}>{option.hotel}</span>
              )}
            />
          </div>
        </div>
        {/* Category Select */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10"><i className="fa fa-chevron-down"></i></span>
            <select className="input pad_lft_rht10" value={params.pmsCategoryId} onChange={e => props.paramChange(e, 'pmsCategoryId')}>
              <option value="">Select Category</option>
              {props.categoryList.map((e, key) => (
                <option key={key} value={e.room_category_id}>{e.room_category_name}</option>
              ))}
            </select>
          </div>
        </div>
        {/* Search By Select */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10"><i className="fa fa-chevron-down"></i></span>
            <select className="input pad_lft_rht10" value={params.searchBy} onChange={e => props.paramChange(e, 'searchBy')}>
              <option value='requested_date'>Requested Date</option>
              <option value='reservation_date'>Reservation Date</option>
            </select>
          </div>
        </div>
        {/* From Date */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <DatePicker
              customInput={<CustomInput />}
              placeholderText="From Date"
              dateFormat="yyyy-MM-dd"
              name="fromDate"
              onChange={e => props.dateChange(e, 'fromDate')}
              selected={params.fromDate !== '' ? new Date(params.fromDate) : null}
            />
          </div>
        </div>
        {/* To Date */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <DatePicker
              customInput={<CustomInput />}
              placeholderText="To Date"
              dateFormat="yyyy-MM-dd"
              name="toDate"
              minDate={params.fromDate !== '' ? new Date(params.fromDate) : null}
              onChange={e => props.dateChange(e, 'toDate')}
              selected={params.toDate !== '' ? new Date(params.toDate) : null}
            />
          </div>
        </div>
      </div>
      <div className="row gutters-5">
        {/* Channel Select */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10">
              <i className="fa fa-chevron-down"></i>
            </span>
            <select
              className="input pad_lft_rht10"
              value={params.channelId}
              onChange={e => props.paramChange(e, 'channelId')}
            >
              <option value="0">All Channel</option>
              {Object.keys(ota).length > 0
                ? Object.keys(ota).map(id => {
                  var data = ota[id];
                  return (
                    <option value={data.channel_id} key={id}>
                      {data.ota_name}
                    </option>
                  );
                })
                : ''}
            </select>
          </div>
        </div>
        {/* Status Select */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10"><i className="fa fa-chevron-down"></i></span>
            <select className="input pad_lft_rht10" value={params.status} onChange={e => props.paramChange(e, 'status')}>
              <option value="all">Status</option>
              <option value='error'>Error</option>
              <option value='completed'>Completed</option>
            </select>
          </div>
        </div>
        {/* Request Type Select */}
        <div className="col-xs-12 col-md marg_bottom10">
          <div className="frm border_all_1 border_color_1">
            <span className="ficon pad_lft_rht10"><i className="fa fa-chevron-down"></i></span>
            <select className="input pad_lft_rht10" value={params.requestType} onChange={e => props.paramChange(e, 'requestType')}>
              <option value="">Request Type</option>
              <option value='rate'>Rate</option>
              <option value='inventory'>Inventory</option>
            </select>
          </div>
        </div>
        {/* Filter and Reset Buttons */}
        <div className="col-xs-12 col-md-auto marg_bottom10">
          <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={() => props.searchLogs()}>
            <i className="fa fa-filter marg_right7"></i>Filter
          </div>
        </div>
        <div className="col-xs-12 col-md-auto marg_bottom10">
          <div className="btn2 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={reset}>
            <i className="fa fa-repeat marg_right7"></i>Reset
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
